import React from 'react';
import styled from 'styled-components';

import MaterialSymbol from 'components/basic/icons/MaterialSymbol';
import { formatNumber } from 'lib/display/formatting';

const Wrap = styled.div`
  display: inline-flex;
  gap: 4px;
  align-items: center;
`;

const IconWrap = styled.div`
  padding-left: 4px;
  cursor: pointer;
`;

const LevelsWrap = styled.div`
  text-align: right;
`;

/** Desktop and Mobile TP/SL Column (Block) */
export default function TPSLColumn({
  stopLossPrice,
  takeProfitPrice,
  tickSizeDecimals,
  onEdit,
}: {
  takeProfitPrice: string | undefined;
  stopLossPrice: string | undefined;
  tickSizeDecimals: number | undefined;
  /** Edit callback or `false` when disabled */
  onEdit: (() => void) | false;
}) {
  return onEdit ? (
    <Wrap>
      <LevelsWrap>
        {takeProfitPrice
          ? formatNumber(takeProfitPrice, {
              fixedDecimals: tickSizeDecimals,
            })
          : '-'}{' '}
        <br />
        {stopLossPrice
          ? formatNumber(stopLossPrice, {
              fixedDecimals: tickSizeDecimals,
            })
          : '-'}
      </LevelsWrap>
      <div>
        /<br />
        &nbsp;
      </div>
      <IconWrap onClick={onEdit}>
        <MaterialSymbol icon="edit" fontSize="small" />
      </IconWrap>
    </Wrap>
  ) : (
    <>-</>
  );
}
